import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let ViedocBoxContent = class ViedocBoxContent extends LitElement {
    render() {
        return html `<slot></slot>`;
    }
};
ViedocBoxContent.styles = [
    css `
      :host {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0.9375rem 1.25rem; /* 15px 20px */
        background-color: var(--secondary-background-color);
      }
    `,
];
ViedocBoxContent = __decorate([
    customElement('viedoc-box-content')
], ViedocBoxContent);
export { ViedocBoxContent };
